<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <DateIOSPicker label="Ngày" :date.sync="date" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="name"
            clear-icon="mdi-close"
            label="Tên lớp bán trú"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            :items="[
              { title: 'Chưa điểm danh', status: 'created' },
              { title: 'Đã điểm danh', status: 'done' },
            ]"
            clear-icon="mdi-close"
            item-text="title"
            item-value="status"
            label="Chọn trạng thái"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn dark outlined class="search-button mb-5" @click="onFilterChanged"> Tìm kiếm </v-btn>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'

export default {
  components: { DateIOSPicker },
  data: () => ({ status: '', name: '', date: moment().toISOString() }),
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        boardingClassTitle_contains: this.name,
        status: this.status,
        date: this.date
      })
    },
  },
  mounted() {
    this.onFilterChanged()
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
